<button
  [type]="type()"
  [disabled]="isDisabled()"
  class="btn"
  [class.btn--primary]="variant() === 'primary'"
  [class.btn--secondary]="variant() === 'secondary'"
  [class.btn--ghost]="variant() === 'ghost'"
  [class.btn--danger]="variant() === 'danger'"
  [class.btn--loading]="loading()"
  [class.btn--sm]="size() === 'sm'"
  [class.btn--md]="size() === 'md'"
  [class.btn--lg]="size() === 'lg'"
  [attr.aria-busy]="loading() || null"
>
  @if (loading()) {
    <app-icon [icon]="spinnerIcon" [size]="16" class="btn__spinner" aria-hidden="true" />
  }
  <span [class.btn__label--hidden]="loading()">
    <ng-content />
  </span>
</button>
